/**
 * Career-guidance content for the /careers section.
 *
 * Data lives in careers.data.json (authored by the expert-research workflow,
 * normalised to ₹). This module adds the TypeScript types + the category
 * filter order. Pure information — no quizzes. India / Plus Two commerce context.
 */
import data from './careers.data.json';

export type CourseCategory =
  | 'Professional'
  | 'Degree'
  | 'Law'
  | 'Analytics'
  | 'Creative'
  | 'Other';

export interface Course {
  name: string;
  slug: string;
  category: CourseCategory;
  tagline: string;
  duration: string;
  eligibility: string;
  whatYouStudy: string[];
  careers: string[];
  demand: string;
  /** 'Moderate' | 'Demanding' | 'Very demanding' */
  level: string;
}

export interface MarketStat {
  value: string;
  label: string;
}

/** Filter order for the category chips (only categories present are shown). */
export const CATEGORY_ORDER: CourseCategory[] = [
  'Professional',
  'Degree',
  'Law',
  'Analytics',
  'Creative',
  'Other',
];

export const whyCommerce: string[] = data.whyCommerce;
export const marketTrends: string[] = data.marketTrends;
export const marketStats: MarketStat[] = data.marketStats;
export const courses: Course[] = data.courses as Course[];
